var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle3NoCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.0212,
    y: 1.22261,
    width: 41.5548,
    height: 41.5548,
    rx: 20.7774,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.0212,
    y: 1.22261,
    width: 41.5548,
    height: 41.5548,
    rx: 20.7774,
    stroke: "#2AA663",
    strokeWidth: 0.848056
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2217 27.9751C21.4411 27.9751 20.7472 27.8414 20.1401 27.574C19.5365 27.3066 19.0595 26.9344 18.709 26.4573C18.3584 25.9803 18.1723 25.4292 18.1506 24.804H20.1888C20.2069 25.1039 20.3063 25.3659 20.487 25.59C20.6677 25.8104 20.908 25.9821 21.208 26.105C21.5079 26.2278 21.844 26.2893 22.2162 26.2893C22.6138 26.2893 22.9661 26.2206 23.2733 26.0833C23.5805 25.9423 23.8208 25.7472 23.9943 25.4978C24.1677 25.2485 24.2527 24.9612 24.249 24.6359C24.2527 24.2998 24.1659 24.0035 23.9888 23.7469C23.8118 23.4903 23.5552 23.2898 23.2191 23.1452C22.8866 23.0006 22.4855 22.9284 22.0157 22.9284H21.0345V21.378H22.0157C22.4023 21.378 22.7402 21.3112 23.0294 21.1774C23.3221 21.0437 23.5516 20.8558 23.7178 20.6137C23.884 20.3679 23.9653 20.0842 23.9617 19.7626C23.9653 19.4482 23.8949 19.1754 23.7503 18.9441C23.6094 18.7092 23.4088 18.5267 23.1486 18.3966C22.892 18.2665 22.5903 18.2014 22.2433 18.2014C21.9036 18.2014 21.5892 18.2629 21.3001 18.3857C21.011 18.5086 20.7779 18.6839 20.6008 18.9115C20.4237 19.1356 20.3298 19.403 20.3189 19.7138H18.3837C18.3982 19.0922 18.5771 18.5465 18.9204 18.0767C19.2673 17.6033 19.7299 17.2347 20.3081 16.9709C20.8863 16.7035 21.535 16.5698 22.2542 16.5698C22.995 16.5698 23.6383 16.7089 24.184 16.9872C24.7333 17.2618 25.1579 17.6322 25.4579 18.0984C25.7578 18.5646 25.9078 19.0796 25.9078 19.6434C25.9114 20.2686 25.7271 20.7926 25.3549 21.2154C24.9863 21.6382 24.502 21.9147 23.9021 22.0448V22.1315C24.6827 22.2399 25.2808 22.529 25.6964 22.9988C26.1156 23.465 26.3234 24.0451 26.3198 24.7389C26.3198 25.3605 26.1427 25.917 25.7885 26.4085C25.438 26.8964 24.9537 27.2795 24.3358 27.5577C23.7214 27.836 23.0167 27.9751 22.2217 27.9751Z",
    fill: "#2AA663"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle3NoCheck);
export default __webpack_public_path__ + "static/media/Circle3NoCheck.1796c56fe78d49223b7d77e2f00e651b.svg";
export { ForwardRef as ReactComponent };